import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown'
import { Button } from '../ui/button'
import AddDetailsIcon from '../../public/icons/add-details.svg'
import FileUpIcon from '../../public/icons/file-up.svg'
import UploadIcon from '../../public/icons/upload-icon.svg'
import TextNoteIcon from '../../public/icons/text-note.svg'

type Props = {
  page?: string;
  showUploadRecording: boolean;
  handleUploadRecording: () => void;
  handleAddTextNode: (val: boolean) => void
}

const CustomerL2Dropdown = ({ page = '', showUploadRecording, handleUploadRecording, handleAddTextNode }: Props) => {
  const [open, setOpen] = useState(false)
  return (
    <DropdownMenu 
      modal={false}
      open={open}
      onOpenChange={setOpen}
    >
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className={`h-fit w-fit ${
            page === 'l1' ? 'bg-secondary hover:bg-secondary' : 'bg-transparent hover:bg-transparent'
          } border-none p-1 rounded-full`}
        >
          {
            page === 'l1' ? (<AddDetailsIcon className={`w-6 h-6 ${page === 'l1' ? 'text-white' : 'text-primary-dark'} fill-current`}/>) : (
              <div className='flex items-center'>
                <FileUpIcon className="w-fit h-6 text-transparent fill-white" />
                <ChevronDown size={24} stroke='#71717A' className={`transition-transform duration-450 ${
                  open ? 'rotate-180' : ''
                }`} />
              </div>
            )
          }
          
          
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        side='bottom' 
        sideOffset={page === 'l1' ? 2 : -2} 
        className='w-[150px] lg:w-[200px] bg-white max-h-[110px] px-0'
      >
        {showUploadRecording && (
          <DropdownMenuItem 
            className='flex items-center gap-2 lg:gap-3 px-3 py-2 w-full hover:bg-[#EDEDED] hover:cursor-pointer'
            onClick={handleUploadRecording}
          >
            <UploadIcon className="w-4 h-4 lg:w-5 lg:h-5"/>
            <span className='text-xs lg:text-sm'>Upload recording</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem 
          className='flex items-center gap-2 lg:gap-3 px-3 py-2.5 w-full hover:bg-[#EDEDED] hover:cursor-pointer'
          onClick={() => handleAddTextNode(true)}
        >
          <TextNoteIcon className="w-4 h-4 lg:w-5 lg:h-5 text-primary-dark stroke-current"/>
          <span className='text-xs lg:text-sm'>Add text note</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default CustomerL2Dropdown